import React, { useEffect, useState } from 'react'
import { MultiSelect } from "react-multi-select-component";
import './finance.scss';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from 'axios';
import { toast } from 'react-toastify';
import Spinner from 'react-bootstrap/Spinner';
import Select from 'react-select';
const base_url = "https://mis-api.happimobiles.com/";
// const base_url='http://localhost:8030/';

const FinanceReports = () => {
  const [selected, setSelected] = useState([]);
  const defaultStartDate = new Date();
  const defaultEndDate = new Date();
  const [startDate, setStartDate] = useState(defaultStartDate);
  const [endDate, setEndDate] = useState(defaultEndDate);
  const [productList, setProductList] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState([]);
  const [itemName, setItemName] = useState("");
  const [itemsList, setItemsList] = useState([]);
  const [financeReportFormData, setFinanceReportFormData] = useState({ submitBtnLoader: false });
  const [selectedItem, setSelectedItem] = useState([]);

  useEffect(() => {
    document.title = 'Finance Reports'
    getProductsData()
  }, []);

  const onChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const getProductsData = async () => {
    try {
      let { data } = await axios(`${base_url}api/finance/productNames`);
      setProductList(data?.productNames)
    }
    catch (e) {
      toast.error("Network error try again later")
    }
  }

  const onProductSelection = async (val) => {
    setBrandList({ loader: true })
    if (!val.length) return setSelectedProduct(val)
    setSelectedProduct(val)
    let { data } = await axios(`${base_url}api/finance/brandNames?product_name=${val.map(item => item.label).toString()}`)
    setBrandList(data?.rows)
  }

  const onProductSingleSelection = async (val) => {
    console.log("val", val)
    setBrandList({ loader: true })
    setSelectedProduct(val)
    setItemName("")
    let { data } = await axios(`${base_url}api/finance/brandNames?product_name=${val?.value}`)
    setBrandList(data?.rows)
  }

  const onBrandSelection = async (val) => {
    setSelectedBrand(val)
    setItemName("")
    let { data } = await axios(`${base_url}api/finance/itemNames?brand_name=${val.value}&product_name=${selectedProduct?.value}`)
    const itemsWithDefaultDate = data?.rows.map(item => ({
      ...item,
      effectiveDate: new Date().toISOString().split('T')[0]
    }));
    setItemsList(itemsWithDefaultDate)
  }

  const getProductOptions = () => productList.length > 0 ? productList?.map(item => ({ label: item, value: item })) : []
  const getBrandOptions = () => brandList.length > 0 ? brandList?.map(item => ({ label: item.brand_name, value: item.brand_name })) : []
  const getItemsOptions = () => itemsList.length > 0 ? itemsList?.map(item => ({ label: item.item_name, value: item.item_name, ...item })) : []

  const onReportSubmit = async () => {
    // Filter items that have MOP values entered
    const itemsToSubmit = itemsList.filter(item => item.mop && item.mop.trim() !== '');
    console.log("itemsToSubmit",itemsToSubmit);

    if (itemsToSubmit.length === 0) {
      return toast.error("Please enter MOP values for at least one item");
    }

    let success_count = 0;
    let errorItems = [];
    setFinanceReportFormData(prev => ({ ...prev, submitBtnLoader: true }));
  

    try {
      // Submit each item with MOP value
      for (const item of itemsToSubmit) {
        const payload = {
          item_name: item.name,
          from_date: item.effectiveDate,
          dp_mop: item.mop,
          on_invoice_disc:item.on_invoice_disc||0,
          on_invoice_spike:item.on_invoice_spike||0,
          // to_date:item.to_date
        };

        console.log(payload, "---");

        let { data } = await axios.post(`${base_url}api/finance/updateDp`, payload);
        if (data?.status) {
          toast.success("Updated " + payload.item_name + " DP: " + payload.dp_mop);
          success_count++;
        } else {
          toast.error("Failed " + payload.item_name + " DP: " + payload.dp_mop);
          errorItems.push(payload)
        }
        await new Promise(r => setTimeout(r, 1000));
      }

      if (success_count === itemsToSubmit.length) {
        toast.success("Success " + success_count + " items updated");
        setItemsList([]);
        let { data } = await axios(`${base_url}api/finance/itemNames?brand_name=${selectedBrand?.value}&product_name=${selectedProduct?.value}`)
        const itemsWithDefaultDate = data?.rows.map(item => ({
          ...item,
          effectiveDate: new Date().toISOString().split('T')[0]
        }));
        setItemsList(itemsWithDefaultDate)
        toast.success("Fetching Submitted Successfully");

      } else {
        toast.error("Some items failed to update" + (itemsToSubmit.length - success_count) + " items failed to update");
      }

      setFinanceReportFormData({ submitBtnLoader: false });

    }
    catch (e) {
      console.log(e.response?.data, "---");
      toast.error(e?.response?.data?.message || "Error submitting data");
      setFinanceReportFormData({ submitBtnLoader: false });
    }
  }

  const onFormDataChange = (e) => {
    setFinanceReportFormData((prev => ({ ...prev, [e.target.name]: e.target.value })))
  }

  function convertToCSV(data) {
    if (!data || data.length === 0) return '';

    const keys = Object.keys(data[0]);
    const csvRows = [
      keys.join(','), // header row
      ...data.map((row) => keys.map(k => `"${(row[k] ?? '').toString().replace(/"/g, '""')}"`).join(','))
    ];

    return csvRows.join('\n');
  }

  function downloadCSV() {
    const csv = convertToCSV(itemsList);
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', selectedBrand?.label);
    link.click();

    URL.revokeObjectURL(url);
  }

  return (
    <>
      <div className='finance-container'>
        <div className='d-flex title-calendar-container align-items-center justify-content-around'>
          <h3 style={{ paddingTop: '10px' }}>Finance Reports</h3>
          <button className="btn btn-danger" disabled={itemsList.length == 0} onClick={downloadCSV}>Export CSV</button>
        </div>
        <div className='formdata'>
          <div className='row'>
            <div className={`col-md-4`}>
              <label>Product Name</label>
              <Select
                options={getProductOptions()}
                value={selectedProduct}
                onChange={onProductSingleSelection}
              />

            </div>
            <div className='col-md-4'>
              <label>Brand Name</label>
              <Select
                options={getBrandOptions()}
                value={selectedBrand}
                onChange={onBrandSelection}
              />

            </div>
            <div className='col-md-4'>
              <label>Item Name</label>
              <input
                type="text"
                placeholder='Item Name / Model name'
                name="itemName"
                value={itemName}
                className='form-control'
                onChange={(e) => setItemName(e.target.value)}
              />

            </div>

          </div>
          <div className='row mt-2'>
            {/* <div className='col-md-4'>
              <input type="text" placeholder='MOP' name="mop" value={financeReportFormData?.mop || ""} className='form-control' onChange={onFormDataChange} disabled={financeReportFormData?.submitBtnLoader} />
            </div> */}
            <div className='col-md-4 mt-2 mt-md-0'>
              {/* <button className={`btn btn-danger w-100 ${financeReportFormData?.submitBtnLoader ? "disabledBtn" : ""}`} onClick={onReportSubmit} disabled={financeReportFormData?.submitBtnLoader}>{financeReportFormData?.submitBtnLoader ? <Spinner animation="border" size="sm" /> : "Submit"}</button> */}

            </div>
            {/* <div className='col-md-4 mt-2 mt-md-0'>
            <input type="text"  className='form-control' value={financeReportFormData?.sale_disc||""} name="sale_disc" placeholder='Sell Out Discount Value' onChange={onFormDataChange} disabled={financeReportFormData?.submitBtnLoader}  />
        </div> */}
          </div>
          <div className='row mt-2'>
            {/* <div className='col-md-4 '>
            <input type="text" className='form-control' value={financeReportFormData?.sale_disc_target||""}  name="sale_disc_target" placeholder='Target Discount' onChange={onFormDataChange} disabled={financeReportFormData?.submitBtnLoader}  />
        </div>
        <div className='col-md-4 mt-2  mt-md-0'>
            <input type="text" className='form-control'  value={financeReportFormData?.spike||""} name="spike" placeholder='Spike' onChange={onFormDataChange} disabled={financeReportFormData?.submitBtnLoader} />
        </div> */}
            <div className='col-md-4 d-flex align-items-center justify-content-end mt-2  mt-md-0'>
              {/* <button className={`btn btn-danger w-100 ${financeReportFormData?.submitBtnLoader?"disabledBtn":""}` } onClick={onReportSubmit} disabled={financeReportFormData?.submitBtnLoader}>{financeReportFormData?.submitBtnLoader?<Spinner animation="border" size="sm" />:"Submit"}</button> */}
            </div>
          </div>

          <div className='row mt-2'>
            {itemsList.length > 0 && (
              <div className='col-md-12 d-flex justify-content-end mb-3'>
                <button
                  className={`btn btn-danger ${financeReportFormData?.submitBtnLoader ? "disabledBtn" : ""}`}
                  onClick={onReportSubmit}
                  disabled={financeReportFormData?.submitBtnLoader}
                  style={{ minWidth: '120px' }}
                >
                  {financeReportFormData?.submitBtnLoader ? <Spinner animation="border" size="sm" /> : "Save"}
                </button>
              </div>
            )}
          </div>

          <div className='row col-md-12'>
            {itemsList.length > 0 && (
              <div className="table-responsive mt-4">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Item Name</th>
                      <th>Brand Name</th>
                      <th>Product Name</th>
                      <th>Current DP/MOP</th>
                      <th>DP/MOP</th>
                      <th>On Invoice Discount (%)</th>
                      <th>On Invoice Spike</th>
                      <th>Effective From Date</th>
                      {/* <th>Effective To Date</th> */}

                    </tr>
                  </thead>
                  <tbody>
                    {itemsList
                      .filter(item =>
                        item?.name?.toLowerCase().includes(itemName.toLowerCase())
                      )
                      .map((filteredItem) => {
                        // Find the original index in itemsList
                        const originalIndex = itemsList.findIndex(item => item.name === filteredItem.name);
                        return (
                          <tr key={originalIndex}>
                            <td>{filteredItem.name}</td>
                            <td>{filteredItem.brand_name}</td>
                            <td>{filteredItem.product_name}</td>
                            <td>{filteredItem.dp_mop}</td>
                            <td>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                value={filteredItem.mop || ''}
                                onChange={(e) => {
                                  // Only allow numbers
                                  const value = e.target.value.replace(/[^0-9]/g, '');
                                  const newItemsList = [...itemsList];
                                  newItemsList[originalIndex] = {
                                    ...newItemsList[originalIndex],
                                    mop: value
                                  };
                                  setItemsList(newItemsList);
                                }}
                              />
                            </td>
                              <td>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                value={filteredItem.on_invoice_disc || ''}
                                onChange={(e) => {
                                  // Only allow numbers
                                  const value = e.target.value.replace(/[^0-9.]/g, '');
                                  const newItemsList = [...itemsList];
                                  newItemsList[originalIndex] = {
                                    ...newItemsList[originalIndex],
                                    on_invoice_disc: value
                                  };
                                  setItemsList(newItemsList);
                                }}
                              />
                            </td>
                              <td>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                value={filteredItem.on_invoice_spike || ''}
                                onChange={(e) => {
                                  // Only allow numbers
                                  const value = e.target.value.replace(/[^0-9]/g, '');
                                  const newItemsList = [...itemsList];
                                  newItemsList[originalIndex] = {
                                    ...newItemsList[originalIndex],
                                    on_invoice_spike: value
                                  };
                                  setItemsList(newItemsList);
                                }}
                              />
                            </td>
                            <td>
                              {/* {filteredItem.effectiveDate} */}
                              <input
                                type="date"
                                className="form-control form-control-sm"
                                value={filteredItem.effectiveDate|| new Date().toISOString().split('T')[0]}
                                onChange={(e) => {
                                  const newItemsList = [...itemsList];
                                  newItemsList[originalIndex] = {
                                    ...newItemsList[originalIndex],
                                    effectiveDate: e.target.value
                                  };
                                  setItemsList(newItemsList);
                                }}
                              />
                            </td>
                               {/* <td>
                              <input
                                type="date"
                                className="form-control form-control-sm"
                                value={filteredItem?.to_date?new Date(filteredItem?.to_date).toISOString().split('T')[0] : new Date().toISOString().split('T')[0]}
                                onChange={(e) => {
                                  const newItemsList = [...itemsList];
                                  newItemsList[originalIndex] = {
                                    ...newItemsList[originalIndex],
                                    to_date: e.target.value
                                  };
                                  setItemsList(newItemsList);
                                }}
                              />
                            </td> */}
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          <div className='row mt-3'>
            {itemsList.length > 0 && (
              <div className='col-md-12 d-flex justify-content-end'>
                <button
                  className={`btn btn-danger ${financeReportFormData?.submitBtnLoader ? "disabledBtn" : ""}`}
                  onClick={onReportSubmit}
                  disabled={financeReportFormData?.submitBtnLoader}
                  style={{ minWidth: '120px' }}
                >
                  {financeReportFormData?.submitBtnLoader ? <Spinner animation="border" size="sm" /> : "Save"}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>

  )
}

export default FinanceReports